export const polygonZaps = [
  {
    // QuickSwap
    zapAddress: '0x540A9f99bB730631BF243a34B19fd00BA8CF315C',
    ammRouter: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff',
    ammFactory: '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32',
    ammPairInitHash: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f',
  },
  {
    // Cometh
    zapAddress: '0x872c9DCE4B107042933AFD51E8A704631f7EE076',
    ammRouter: '0x93bcDc45f7e62f89a8e901DC4A0E2c6C427D9F25',
    ammFactory: '0x800b052609c355cA8103E06F022aA30647eAd60a',
    ammPairInitHash: '0x499154cad90a3563f914a25c3710ed01b9a43b8471a35ba8a66a056f37638542',
  },
  {
    // Sushi
    zapAddress: '0xf039fe26456901F863c873556f40fb207C6c9C18',
    ammRouter: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    ammFactory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    ammPairInitHash: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  },
];
